
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { IBreadCrumb } from "winfakt-vue-components";
import { Dossier } from "../../../models/dossier/dossier";
import { DossierService } from "../../../services/dossier-service";
import AppCountryCodeAutocomplete from "@/components/CountryCodeAutocomplete.vue";
import { AuthService } from "@/services/auth-service";
import AppDossierEditAutoFillModal, { IAutoFillSelectedFields } from "@/components/settings-default/DossierEditAutoFillModal.vue";
import { ContactAutofill } from "@/models/contact-autofill";
import { AllContactsService } from "@/services/all-contacts-service";
import { checkVAT, countries } from "jsvat-next";

export default Vue.extend({
	data(){
		return {
			value: new Dossier(),
			autoFillData: null as null | ContactAutofill,
			vatNumberBlured: false
		};
	},
	computed: {
		title():string{
			let title = "create-dossier";
			if (this.value.id){
				title = "edit-dossier";
			}
			return this.$ct(title).toString();
		},
		path():IBreadCrumb[] {

			return [
				{
					to: "/settings",
					value: this.$ct("general")
				},
				{
					to: "/settings/company",
					value: this.$ct("company")
				},
				{
					value: this.title
				}
			] as IBreadCrumb[];
		},
		vatIsValid():boolean{
			if (this.value.vatNumber == "") {
				return true;
			}
			let vatNo = this.value.vatNumber.replaceAll(".", "").replaceAll(" ", "");
			console.log(vatNo);
			if (/^[0-9]{8,12}$/.test(vatNo)){
				return true;
			}
			let result = checkVAT(vatNo, countries);
			return result.isValid;
		}
	},
	methods: {
		back(){
			this.$router.back();
		},
		async save(){
			if (this.value.id){
				this.value = await DossierService.updateDossier(this.value);
				this.back();
			}else{
				this.value = await DossierService.createDossier(this.value);
				await AuthService.refreshTokens(); // Makes sure accessToken is fetched for new dossier
				await AuthService.getUserInfo();
				let confirm = await this.$confirmBuilder(this.$ct("confirm-switch-to-new-dossier")).show();
				if (confirm){
					AuthService.selectDossier(this.value.name);
				}else{
					this.back();
				}
			}
		},
		async onVatBlur(){
			this.vatNumberBlured = true;
			try {
				this.autoFillData = await AllContactsService.autoFill(this.value.vatNumber);
			} catch (err) {
			}
		},
		autoFill(data:IAutoFillSelectedFields){
			if (!this.autoFillData) return;
			if (data.address) {
				let split = ContactAutofill.splitAddressIntoAddressAndNumber(this.autoFillData.address || "");
				this.value.streetName = split.address;
				this.value.streetNumber = split.nr;
			}
			if (data.postal) {
				this.value.postalCode = this.autoFillData.postal || this.value.postalCode;
			}
			if (data.city) {
				this.value.cityName = this.autoFillData.city || this.value.cityName;
			}
			if (data.tel) {
				this.value.phone = this.autoFillData.tel || this.value.phone;
			}
			if (data.companyName) {
				this.value.name = this.autoFillData.maatschappelijkeNaam || this.value.name;
			}
		}
	},
	async created(){
		let id = parseInt(this.$route.params.id || "0");
		if (id != 0){
			this.value = await DossierService.getDossier(id);
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppCountryCodeAutocomplete,
		AppDossierEditAutoFillModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
